'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CumulativeValuesCheckbox = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CumulativeValuesCheckbox = function CumulativeValuesCheckbox(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.use_cumulative_values,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px'
    });
};

exports.CumulativeValuesCheckbox = CumulativeValuesCheckbox;
exports.default = CumulativeValuesCheckbox;
//# sourceMappingURL=CumulativeValues.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/CumulativeValues.js
 ** module id = 353
 ** module chunks = 0
 **/